<template>
    <div class="content-data">
        <div class="data-title">
            <div class="data-item" v-for="(item,index) in list" :key="index">
                <div class="data-item-name">{{ item.statusLabel }}</div>
                <div class="data-item-math">{{ item.count }}</div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    name: 'dataTitle',
    props: {
      list:{
        type:Array,
        default : ()=>[],
      }
    },
}
</script>
<style lang="scss" scoped>
.content-data {
    width: 100%;
    background-color: #FFFFFF;
    box-sizing: border-box;
    border-radius: 12px;
    
}

.data-title {
    height: 121px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

}

.data-item {
    width: 396px;
    height: 60px;
    border-right: 2px solid #EDF2F2;
}

.data-item:last-child {
    border-right: none;
}

.data-item-name {
    margin: -5px 0 16px 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #939696;
    line-height: 22px;
}

.data-item-math {
    margin-left: 40px;
    font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
    font-weight: bold;
    font-size: 32px;
    color: #2F3030;
    line-height: 22px;
}

.online {
    width: 2px;
    height: 56px;
    background-color: #EDF2F2;
}
</style>